import React, { useState } from 'react'
import { FaBed} from 'react-icons/fa'
import StayForm from '../ui/searchForms/StayForm'
import { GiVikingLonghouse } from "react-icons/gi";
import HallForm from '../ui/searchForms/HallForm'
import { useTranslation } from 'react-i18next'

const SearchPart = () => {
    const [activeTab, setActiveTab] = useState<'stay' | 'hall'>('stay')
    const { t, i18n } = useTranslation()
    const isRTL = i18n.language === 'ar'

    return (
        <div className='padding-container ' dir={isRTL ? 'rtl' : 'ltr'}>
            
            <div className="flex bg-gray-200 p-3 w-fit gap-5 text-sm rounded-t-lg">
                <button
                    onClick={() => setActiveTab('stay')}
                    className={`flex-center gap-2 px-4 py-2 text-black rounded-lg  font-medium transition ${activeTab === 'stay'
                            ? 'bg-secondry text-white'
                            : ' '
                        }`}
                >
                    <FaBed className=' text-lg' />
                    {t('stay-tab')}
                </button>
                <button
                    onClick={() => setActiveTab('hall')}
                    className={` flex-center gap-2 px-4 py-2 text-black rounded-lg  font-medium transition ${activeTab === 'hall'
                            ? 'bg-secondry text-white'
                            : ''
                        }`}
                >
                    <GiVikingLonghouse className=' text-lg'/>
                    {t('hall-tab')}
                </button>
            </div>
            <div className={`bg-gray-200  rounded-lg ${i18n.language==="ar"?"rounded-tr-none":"rounded-tl-none"}`}>
                {activeTab === 'stay' && <StayForm />}
                {activeTab === 'hall' && <HallForm />}
            </div>
        </div>
    )
}

export default SearchPart
